import { Download } from 'lucide-react';

import { lang } from '@lang';
import { useAppToast, useDesign } from '@hooks';
import { Feature, FeatureHoookParams } from '..';

import { ComponentController, generateDxfFileInternal } from '@rta/rta-blueprint-component';

type GenerateDxfFeatureParams = FeatureHoookParams;
export const useGenerateDxfFeature = (_params: GenerateDxfFeatureParams = {}): Feature<string | null> => {
	const [controller] = useDesign();
	const appToast = useAppToast();

	const [disabled, tooltip] = (() => {
		if (controller === null) return [true, lang.social.tooltip.noGenerateDxf];
		return [false, lang.social.tooltip.generateDxf];
	})();

	return {
		name: 'generateDxf',
		label: lang.social.label.generateDxf,
		icon: (props = {}) => <Download {...props} />,
		tooltip,
		disabled,
		value: null,
		hidden: false,
		handler: () => {
			appToast.info({ title: lang.social.message.generateDxf });
			if (controller) {
				generateDxfFileInternal(controller as unknown as ComponentController);
			}
		}
	};
};
